import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_outbound_order_details_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectId?: number, warehouseId?: number[], fromDate?: string, toDate?: string, orderIds?: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, VendorReference?: string, Account?: { Id?: number, Name?: string }, OrderClass?: { Id?: number }, ShipmentOrderLookups?: { ShipmentId?: number }[], OrderLines?: { LineNumber?: number }[], Project?: { LookupCode?: string } }, Shipment?: { Id?: number, ShippedDate?: string, Carrier?: { Name?: string } }, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { Name?: string, ShortName?: string }, ActualTargetLicensePlate?: { GrossWeight?: number, LookupCode?: string, NetWeight?: number } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectId?: number, warehouseId?: number[], fromDate?: string, toDate?: string, orderIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, VendorReference?: string, Account?: { Id?: number, Name?: string }, OrderClass?: { Id?: number }, ShipmentOrderLookups?: { ShipmentId?: number }[], OrderLines?: { LineNumber?: number }[], Project?: { LookupCode?: string } }, Shipment?: { Id?: number, ShippedDate?: string, Carrier?: { Name?: string } }, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { Name?: string, ShortName?: string }, ActualTargetLicensePlate?: { GrossWeight?: number, LookupCode?: string, NetWeight?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectId?: number, warehouseId?: number[], fromDate?: string, toDate?: string, orderIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, VendorReference?: string, Account?: { Id?: number, Name?: string }, OrderClass?: { Id?: number }, ShipmentOrderLookups?: { ShipmentId?: number }[], OrderLines?: { LineNumber?: number }[], Project?: { LookupCode?: string } }, Shipment?: { Id?: number, ShippedDate?: string, Carrier?: { Name?: string } }, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { Name?: string, ShortName?: string }, ActualTargetLicensePlate?: { GrossWeight?: number, LookupCode?: string, NetWeight?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectId?: number, warehouseId?: number[], fromDate?: string, toDate?: string, orderIds?: number[]    }) {
      return false;
    }
}
